<script setup lang="ts">
import type { ThemeInfoInterface } from '@/models'

interface TProps {
  index: number
  themeInfo: ThemeInfoInterface
}

const props = withDefaults(defineProps<TProps>(), {
  index: -1,
})

const emits = defineEmits(['clicked'])

const onClick = () => {
  emits('clicked', props.themeInfo.id)
}
</script>

<template>
  <label
    v-if="themeInfo"
    :tabindex="index > 0 ? -1 : 0"
    :for="themeInfo.id"
    :class="`theme-radio ${themeInfo.id} ${themeInfo.selected ? 'selected' : ''}`.trim()"
    @click.prevent="onClick"
  >
    <div :aria-label="`Theme ${themeInfo.id}`" :style="`color: ${themeInfo.iconWrapperColor}`">
      <span class="sr-only">{{ themeInfo.id }}</span>
      <svg
        class="size-6"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        :fill="`${themeInfo.selected ? 'currentColor' : 'none'}`"
        :stroke="themeInfo.iconStrokeColor"
        :stroke-width="`${themeInfo.selected ? 2 : 1}`"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
      </svg>
    </div>
    <input
      :id="themeInfo.id"
      type="button"
      class="icon-button"
      name="theme"
      :value="themeInfo.selected"
      v-model="themeInfo.selected"
      @click="onClick"
    />
  </label>
</template>
